import { useState } from 'react';
import { CacheKey as Ck } from '@libs/vercel-edge-rt';
import { useCacheKey } from '@libs/common-next';
import { Key } from './key';
import { Card } from './card';
import css from './cache-key.module.scss';

export function CacheKey() {
    const ck = useCacheKey();
    const [value, setValue] = useState(ck.key);
    const { headers, cookies, search } = Ck.decode(value);

    return (
        <div className={css.wrapper}>
            <Key value={value} onChange={setValue} />

            <div className={css.details}>
                <Card title="Headers" data={headers} />
                <Card title="Cookies" data={cookies} />
                <Card title="Query params" data={search} />
            </div>
        </div>
    );
}
